module.exports = __webpack_public_path__ + "static/media/spoonerism-task (1).ca8dd4c7.mp3";